import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "website-importer-blob3",
  "use": "website-importer-blob3-usage",
  "viewBox": "0 0 38 39",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 39\" id=\"website-importer-blob3\"><circle cx=\"19\" cy=\"19.508\" r=\"19\" fill=\"#583BB6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol